import { useEffect, useState } from "react";
import { FaUsers } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { InlineWidget } from "react-calendly";

import Loading from "common/components/loading";

const BookASession = () => {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  return (
    <section
      className=" mx-auto flex flex-col gap-10 px-4  "
      id="book-a-session"
    >
      <div className="flex w-full flex-col justify-center gap-6 pt-10 text-center leading-9 text-black ">
        <div className="flex justify-center gap-2">
          <div className=" my-auto flex h-10 w-10 items-center  justify-center rounded-lg bg-primary-500  text-white duration-75 ease-in-out hover:text-black">
            <FaUsers size={30} />
          </div>
          <h6 className="uppercase tracking-wider">
            {t("common.bookASession")}
          </h6>
        </div>
        <h3 className="text-4xl font-semibold">{t("contactUs.title")}</h3>
      </div>
      {loading ? (
        <div className="flex h-screen items-center justify-center">
          <Loading />
        </div>
      ) : (
        <div className="mb-12 grid w-full grid-cols-1 gap-6 overflow-hidden lg:grid-cols-2">
          <InlineWidget
            url="https://calendly.com/submitapp-contact/book-a-session"
            styles={{
              height: "1600px",
            }}
            pageSettings={{
              backgroundColor: "ffffff",
              primaryColor: "D90000",
              textColor: "4d5055",
            }}
          />
          <InlineWidget
            url="https://calendly.com/submitapp-contact/submitapp-portal-demo-spanish-english-language-options"
            styles={{
              height: "1600px",
            }}
            pageSettings={{
              backgroundColor: "ffffff",
              primaryColor: "D90000",
              textColor: "4d5055",
            }}
          />
        </div>
      )}
    </section>
  );
};

export default BookASession;
